import { render, staticRenderFns } from "./MobileLayout.vue?vue&type=template&id=33a486b3"
import script from "./MobileLayout.vue?vue&type=script&lang=js"
export * from "./MobileLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports